import React from 'react';
import PropTypes from 'prop-types';
import { Label, Vertical } from './elements';
import useDirections from '../../MapWidget/useDirections.hook';

function LoadedMileageFrame({
  fromWaypoint,
  toWaypoint,
  variant,
  grow,
  isRequestCompleted,
  distance,
  departureTimeForMileageCalculation,
}) {
  const directions = useDirections(fromWaypoint, toWaypoint, departureTimeForMileageCalculation);

  switch (variant) {
    case 'vertical':
      return (
        <>{directions && <Vertical grow={grow}>{isRequestCompleted ? distance : directions.distance}</Vertical>}</>
      );
    default:
      return (
        <>
          {directions && (
            <Label>
              Loaded Mileage:&nbsp;
              {isRequestCompleted ? distance : directions.distance}
            </Label>
          )}
        </>
      );
  }
}

LoadedMileageFrame.propTypes = {
  from: PropTypes.shape(),
  to: PropTypes.shape(),
  variant: PropTypes.string,
  grow: PropTypes.bool.isRequired,
  departureTimeForMileageCalculation: PropTypes.string,
};

LoadedMileageFrame.defaultProps = {
  variant: null,
  from: null,
  to: null,
  departureTimeForMileageCalculation: null,
};

export default LoadedMileageFrame;
